import { AlertTriangle, Download, Calendar } from "lucide-react";
import { CTAButton } from "../shared/CTAButton";
const FinalCTACard = () => {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    formElement?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 sm:py-28 lg:py-32">
      <div className="container max-w-4xl mx-auto px-6 sm:px-8">
        <div className="border border-accent/30 rounded-xl p-10 sm:p-12 backdrop-blur-sm bg-gradient-to-r from-accent/5 to-destructive/5 text-center">
          
          {/* Badge */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex items-center gap-2 border border-accent/30 px-4 py-2 rounded-full">
              <AlertTriangle className="w-4 h-4 text-accent" />
              <span className="text-xs font-semibold text-accent uppercase tracking-wide">LETZTE CHANCE</span>
            </div>
          </div>
          
          {/* H2 */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Noch unsicher? <span className="text-accent">
Jede Sekunde zählt!</span>
          </h2>
          
          {/* Subtext */}
          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed mb-10 max-w-2xl mx-auto md:text-lg">
            Laden Sie die Checkliste kostenlos herunter und schützen Sie Ihre Praxis noch heute. 
            Oder buchen Sie einen kostenlosen Beratungstermin für individuelle Unterstützung.
          </p>
          
          {/* CTAs - zentriert */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-xl mx-auto">
            <CTAButton onClick={scrollToForm} icon={Download} className="flex-1 justify-center text-base sm:text-lg px-8 py-4">
              Kostenlos herunterladen
            </CTAButton>
            
            <CTAButton href="/termin-buchen" icon={Calendar} className="flex-1 justify-center text-base sm:text-lg px-8 py-4">
              Beratungstermin buchen
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
};
export default FinalCTACard;